/**
 * Premium PDP interactions — roseonsix-lun-premium.html
 */
import { findVariant } from '@theme/lunera-bundle-dropdowns';

function readProductData() {
  const el = document.getElementById('lunera-product-data');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function scrollToPdp() {
  document.getElementById('lun-pdp')?.scrollIntoView({ behavior: 'smooth' });
}

function setMainImage(mainImg, { src, srcset, mediaId }) {
  if (!mainImg || !src) return;
  mainImg.style.opacity = '0';
  setTimeout(() => {
    mainImg.src = src;
    if (srcset) {
      mainImg.srcset = srcset;
    } else {
      mainImg.removeAttribute('srcset');
    }
    if (mediaId) {
      mainImg.dataset.mediaId = String(mediaId);
    }
    mainImg.style.opacity = '1';
  }, 180);
}

function activateThumb(mediaId) {
  if (!mediaId) return;
  document.querySelectorAll('#thumbs button').forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.mediaId === String(mediaId));
  });
}

function initGallery() {
  const mainImg = document.getElementById('mainImg');
  if (!mainImg) return;

  document.querySelectorAll('#thumbs button').forEach((btn) => {
    btn.addEventListener('click', () => {
      activateThumb(btn.dataset.mediaId);
      setMainImage(mainImg, {
        src: btn.dataset.src,
        srcset: btn.dataset.srcset,
        mediaId: btn.dataset.mediaId,
      });
    });
  });
}

function resolveVariantImage(data, variant) {
  if (!variant || !data) return null;
  if (variant.mediaId && Array.isArray(data.media)) {
    const media = data.media.find((item) => String(item.id) === String(variant.mediaId));
    if (media) return media;
  }
  if (variant.image) {
    return { src: variant.image, mediaId: variant.mediaId };
  }
  return null;
}

function getSelection() {
  const colorBtn = document.querySelector('#swatches .sw.active');
  const sizeBtn = document.querySelector('#sizes .sz.active');
  return {
    color: colorBtn?.dataset.name || null,
    size: sizeBtn?.dataset.name || null,
  };
}

function applyVariant(data, variant) {
  if (!variant) return;

  const idInput = document.getElementById('lun-variant-id');
  if (idInput) idInput.value = String(variant.id);

  document.querySelectorAll('#sizes .sz').forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.name === variant.size);
    btn.disabled = !findVariant(data, variant.color, btn.dataset.name)?.available;
    btn.style.opacity = btn.disabled ? '0.4' : '';
  });

  document.querySelectorAll('#swatches .sw').forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.name === variant.color);
  });

  const colName = document.getElementById('colName');
  if (colName) colName.textContent = variant.color;

  const media = resolveVariantImage(data, variant);
  if (media?.src) {
    const mainImg = document.getElementById('mainImg');
    const thumb = media.mediaId
      ? document.querySelector(`#thumbs button[data-media-id="${media.mediaId}"]`)
      : null;
    setMainImage(mainImg, {
      src: media.src,
      srcset: thumb?.dataset.srcset,
      mediaId: media.mediaId,
    });
    activateThumb(media.mediaId);
  }

  const bundles = document.querySelector('lunera-bundles');
  bundles?.setItemSelection?.(0, variant.color, variant.size);
}

function syncVariantFromUi(data) {
  const sel = getSelection();
  if (!sel.color || !sel.size) return;
  const variant = findVariant(data, sel.color, sel.size);
  applyVariant(data, variant);
}

function initVariantPickers(data) {
  if (!data) return;

  document.querySelectorAll('#swatches .sw').forEach((sw) => {
    sw.addEventListener('click', () => {
      document.querySelectorAll('#swatches .sw').forEach((x) => x.classList.remove('active'));
      sw.classList.add('active');
      const colName = document.getElementById('colName');
      if (colName) colName.textContent = sw.dataset.name || '';
      syncVariantFromUi(data);
    });
  });

  document.querySelectorAll('#sizes .sz').forEach((sz) => {
    sz.addEventListener('click', () => {
      if (sz.disabled) return;
      document.querySelectorAll('#sizes .sz').forEach((x) => x.classList.remove('active'));
      sz.classList.add('active');
      syncVariantFromUi(data);
    });
  });

  syncVariantFromUi(data);
}

function setZone(i) {
  document.querySelectorAll('.dot').forEach((d) => d.classList.toggle('active', d.dataset.zone === i));
  document.querySelectorAll('.zone').forEach((z) => z.classList.toggle('active', z.dataset.zone === i));
}

function initZones() {
  document.querySelectorAll('.dot').forEach((d) => d.addEventListener('click', () => setZone(d.dataset.zone)));
  document.querySelectorAll('.zone').forEach((z) => z.addEventListener('click', () => setZone(z.dataset.zone)));
}

function updateBundlePrices(detail) {
  const { now, was, save } = detail || {};
  const priceNow = document.getElementById('priceNow');
  const priceWas = document.getElementById('priceWas');
  const saveTag = document.getElementById('saveTag');
  const atcPrice = document.getElementById('atcPrice');
  const stickyPrice = document.getElementById('stickyPrice');
  const stickyWas = document.getElementById('stickyWas');

  if (now && priceNow) priceNow.textContent = now;
  if (priceWas) {
    if (was && save) {
      priceWas.textContent = was;
      priceWas.hidden = false;
    } else {
      priceWas.textContent = '';
      priceWas.hidden = true;
    }
  }
  if (saveTag) {
    if (save) {
      saveTag.textContent = save;
      saveTag.hidden = false;
    } else {
      saveTag.textContent = '';
      saveTag.hidden = true;
    }
  }
  if (now && atcPrice) atcPrice.textContent = now;
  if (now && stickyPrice) stickyPrice.textContent = now;
  if (stickyWas) {
    if (was && save) {
      stickyWas.textContent = was;
      stickyWas.hidden = false;
    } else {
      stickyWas.textContent = '';
      stickyWas.hidden = true;
    }
  }
}

function initSticky() {
  const sticky = document.getElementById('stickyBar');
  const atcBtn = document.getElementById('atcBtn');
  if (!sticky || !atcBtn) return;

  window.addEventListener(
    'scroll',
    () => {
      const r = atcBtn.getBoundingClientRect();
      sticky.classList.toggle('show', r.bottom < 0);
    },
    { passive: true }
  );

  document.getElementById('stickyAtc')?.addEventListener('click', () => atcBtn.click());
  document.querySelectorAll('.lun-scroll-pdp').forEach((btn) => btn.addEventListener('click', scrollToPdp));
}

function initReveal() {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
}

document.addEventListener('lunera:bundle-prices', (e) => {
  updateBundlePrices(e.detail);
});

document.addEventListener('DOMContentLoaded', () => {
  const data = readProductData();
  initGallery();
  initVariantPickers(data);
  initZones();
  initSticky();
  initReveal();
});
